import {
  ChallengeType,
  type RegisterIdentity,
  type RequestAttestation,
} from '~/interfaces/auth';

import { SignupHandler } from './signup-handler';

export class EmailHandler extends SignupHandler<
  RequestAttestation,
  RegisterIdentity
> {
  protected transformRequestBody(body: RequestAttestation): RegisterIdentity {
    const phone = body.data.phone;
    const email = body.data.email;

    return {
      assertion_result: {
        challengeType: ChallengeType.OTP,
        alias: email,
        value: {
          code: body.assert.code,
          email: email,
        },
      },
      extra_context: {},
      type: 'individual',
      profile: {
        first_name: body.data.name,
        last_name: body.data.lastName,
        email: email,
        phone: phone,
      },
    };
  }
}
